{
  "version": 1,
  "asset_id": "793ab8bc-9af9-41a3-99e3-a8b879811eea",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/793ab8bc-9af9-41a3-99e3-a8b879811eea/texturerad-crop-ovanifran.png",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/793ab8bc-9af9-41a3-99e3-a8b879811eea/texturerad-crop-ovanifran.png",
  "original_filename": "texturerad-crop-ovanifran.png",
  "size": 2023431,
  "content_type": "image/png",
  "created_at": "2026-09-08T13:59:22Z"
}
